import React, { Component } from 'react';
import { Accordion } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import CarInquiryForm from '../rental/CarInquiryForm';
import { abouts } from './abouts';
import logo from '../../images/logo-blue.png';

class RentalsPage extends Component {
  state = { activeIndex: -1 };

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    this.setState({ activeIndex: activeIndex === index ? -1 : index });
  };

  componentDidUpdate() {
    const options = {
      margin: 10, touchDrag: true, rewind: true, animateIn: true,
      responsive: {
        0: { items: 1, nav: false, autoWidth: true },
        600: { items: 1, nav: false },
        1000: { items: 3, nav: true, navText: [
          "<i class='fas fa-chevron-circle-left text-primary'></i>",
          "<i class='fas fa-chevron-circle-right text-primary'></i>"
        ], loop: false }
      }
    };
    if (typeof $ !== 'undefined') $('.owl-carousel').owlCarousel(options);
  }

  render() {
    const { t } = this.props;
    const { activeIndex } = this.state;
    return (
      <>
        <header id="header" className="cover rentals-hero" role="banner">
          <div className="rentals-hero__bg-video" aria-hidden="true">
            <video className="rentals-hero__video" autoPlay muted loop playsInline poster="https://images.unsplash.com/photo-1569929233545-4e44f2a30916?w=1920">
              <source src="https://assets.mixkit.co/videos/preview/mixkit-car-travelling-on-a-winding-mountain-road-4173644-large.mp4" type="video/mp4" />
            </video>
          </div>
          <div className="rentals-hero__overlay" aria-hidden="true" />
          <div className="container position-relative">
            <div className="row headingtext-contact-container">
              <div className="col-12 col-md-8 heading-text">
                <h1 className="rentals-hero__title">
                  Plan your trip across Nepal
                </h1>
                <p className="rentals-hero__sub">
                  {t ? t('WithinNepal') : 'Book your vehicle in one place. No calling around — just pick your route and go.'}
                </p>
              </div>
            </div>
            <CarInquiryForm {...this.props} />
          </div>
        </header>
        <section className="white">
          <div className="ui container">
            <Accordion styled fluid>
              {abouts().map((about, index) => (
                <React.Fragment key={index}>
                  <Accordion.Title active={activeIndex === index} index={index} onClick={this.handleClick}>
                    <h3 className="text-bold mb-2 py-2"><i className="fas fa-car" /> {about.question}</h3>
                    {activeIndex !== index && <p className="m-0">{about.answer.slice(0, 200)}... </p>}
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex === index}><p>{about.answer}</p></Accordion.Content>
                </React.Fragment>
              ))}
            </Accordion>
          </div>
        </section>
        <section>
          <div className="container">
            <div className="testimonial owl-carousel owl-theme">
              {[
                { p: 'Must say that we found the best app for planning our tour to allow us to easily book the car for our planned destinations. Also Couldn\'t find a better price for packages myself! Keep it up.', h: 'Samrat Pradhan' },
                { p: 'Feels like a good friend who knows me is making a holiday packages for myself.', h: 'Sumit Shakya' },
                { p: 'One stop solution for all our booking car problems. No need to find the phone numbers and keep calling. Solved my long awaiting problem. Keep up the good work!!', h: 'Mahesh Gautam' },
                { p: 'Fell in love with your kind and support, the enquiry here helped us decide quickly & after research elsewhere, we came back to book the holiday trip here. Highly recommend!', h: 'Aayush Raut' },
              ].map((a, i) => (
                <article key={i}>
                  <figure><img alt="visitallnepal" src={logo} /></figure>
                  <div><p>{a.p}</p><h1>{a.h}</h1></div>
                </article>
              ))}
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default withTranslation()(RentalsPage);
